import styled, { css } from 'styled-components/macro'

import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { Container } from 'components/container'
import { Logo as LogoCT } from './logo'

export const ObservedPoint = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 5rem;
`

export const StyledHeader = styled.header<{
  $onTop?: boolean
  hasScrolled?: boolean
  isTransparent: boolean
}>`
  position: sticky;
  top: 0;
  width: 100%;
  padding-top: env(safe-area-inset-top);
  font-size: 1.6rem;
  z-index: 200;
  transition: all 0.4s;
  backdrop-filter: blur(12px);
  color: var(--text-color);
  border-bottom: 1px solid var(--text-color);
  background: var(--background);

  ${props =>
    props.$onTop &&
    css`
      position: fixed;

      ${!props.hasScrolled &&
      props.isTransparent &&
      css`
        backdrop-filter: none;
        background-color: transparent;
      `}
    `}

  > ${Container} {
    display: flex;
    align-items: center;
    height: calc(var(--header-height) - env(safe-area-inset-top));
  }
`

export const Logo = styled(LogoCT)`
  height: 2.9rem;
  width: auto;
  display: block;

  ${mq.medium} {
    height: 4.2rem;
  }
`

export const LogoContainer = styled.a`
  width: 8.1rem;
  transition: all 0.3s, 0.4s opacity 0.55s;
  color: inherit;

  &:hover,
  &:focus {
    color: inherit;
  }

  ${mq.smallOnly} {
    width: 9.2rem;

    &.enter {
      opacity: 0;
      width: 1px;
    }

    &.enter-active {
      opacity: 1;
      width: 8.1rem;
      transition-delay: 0.5s;
    }

    &.exit {
      opacity: 1;
      width: 8.1rem;
    }

    &.exit-active,
    &.exit-done {
      opacity: 0;
      width: 1px;
    }
  }
`

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  right: var(--container-spacing);
  width: 1.9rem;
  height: var(--header-height);
  box-sizing: content-box;
  flex-shrink: 0;
  transition: 0.4s opacity 0.55s;
  z-index: 600;

  ${mq.medium} {
    width: auto;
  }
`

export const CloseButton = styled.li`
  margin-top: -0.1em;
  padding: 0.8rem;

  button {
    ${styleReset}
    display: block;
    position: relative;
    cursor: pointer;
    width: 1.6rem;
    height: 1.6rem;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: 2px solid white;
      transform: rotateZ(45deg);
    }

    &::after {
      transform: rotateZ(-45deg);
    }
  }

  ${mq.smallOnly} {
    button::before,
    button::after {
      border-top-color: ${theme.colors.accent.secondary};
    }
  }
`
